export const CATALOG_URL_ID = 'c'
export const SEGMENTATION_PARAM = 's'
